import * as React from 'react';
import { SavedSurveyItem, SurveyItemType } from 'client/shared/core/question';
import { HtmlContent } from 'client/shared/components/base';
import { Typography } from '@mui/material';

export interface SurveyHeaderProps {
  readonly header: Extract<
    SavedSurveyItem,
    { readonly type: SurveyItemType.HEADER }
  >;
  readonly headerCount: number;
}

export const SurveyHeader: React.FC<SurveyHeaderProps> = (props) => {
  return (
    <>
      <Typography py="1.5rem" variant="h2">
        {props.header.data.title}
      </Typography>
      {props.header.data.descriptionHtml && (
        <HtmlContent
          html={props.header.data.descriptionHtml}
          imageAlt="description"
        />
      )}
    </>
  );
};
